import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

export interface UserMaterialAddAgentUserMaterialFolderResponse {
  message: string;
};


class UserMaterialAddAgentUserMaterialFolderData {
  @IsString("Folder name must be a string")
  message: string;
}

const transformAndValidateData = (
  response: UserMaterialAddAgentUserMaterialFolderResponse
): UserMaterialAddAgentUserMaterialFolderData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UserMaterialAddAgentUserMaterialFolderData);
  } catch (error) {
    console.error("User material add agent user material folder data validation failed:", error.message);
    throw error;
  }
};

/** 创建智能体用户素材库 */
export const userMaterialAddAgentUserMaterialFolder = async ({
  agentId,
  userId,
  folderId,
  type
}: {
  agentId: string,
  userId: string,
  folderId: number[],
  type: number
}) => {
  const res = await api.post<UserMaterialAddAgentUserMaterialFolderResponse>('/user_material/add_agent_user_material_folders', {
    agent_id: agentId,
    user_id: userId,
    folder_id: folderId,
    type: type,
  });
  const data = transformAndValidateData(res.data);
  return data;
}